import _regeneratorRuntime from "/codebuild/output/src386676321/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(rootSaga);

import { fork } from 'redux-saga/effects';
import movie from './movie';
import news from './news';
import signIn from './signIn';
import payment from './payment';
import user from './user';
import signUp from './signUp';
import userVerify from './userVerify';
import category from './category';
import payment_movies from './payment_movies';
import category_movies from './category_movies';
import instructor from './instructor';
import signOut from './signOut';
import contact from './contact';
import question_category from './question_category';
import question from './question';
import user_refresh from './user_refresh';
import forgot_password from './forgot_password';
import reset_password from './reset_password';
import license from './license';
import campaign_code from './campaign_code';
import push_token from './push_token';
import cart from './cart';
import discount_pack from './discount_pack';
import bronze_test from './bronze_test';
import homemade from './homemade';
import online_test_log from './online_test_log';
export default function rootSaga() {
  return _regeneratorRuntime.wrap(function rootSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return fork(movie);

        case 2:
          _context.next = 4;
          return fork(news);

        case 4:
          _context.next = 6;
          return fork(signIn);

        case 6:
          _context.next = 8;
          return fork(payment);

        case 8:
          _context.next = 10;
          return fork(user);

        case 10:
          _context.next = 12;
          return fork(signUp);

        case 12:
          _context.next = 14;
          return fork(userVerify);

        case 14:
          _context.next = 16;
          return fork(category);

        case 16:
          _context.next = 18;
          return fork(payment_movies);

        case 18:
          _context.next = 20;
          return fork(category_movies);

        case 20:
          _context.next = 22;
          return fork(instructor);

        case 22:
          _context.next = 24;
          return fork(signOut);

        case 24:
          _context.next = 26;
          return fork(contact);

        case 26:
          _context.next = 28;
          return fork(question_category);

        case 28:
          _context.next = 30;
          return fork(question);

        case 30:
          _context.next = 32;
          return fork(user_refresh);

        case 32:
          _context.next = 34;
          return fork(forgot_password);

        case 34:
          _context.next = 36;
          return fork(reset_password);

        case 36:
          _context.next = 38;
          return fork(license);

        case 38:
          _context.next = 40;
          return fork(campaign_code);

        case 40:
          _context.next = 42;
          return fork(push_token);

        case 42:
          _context.next = 44;
          return fork(cart);

        case 44:
          _context.next = 46;
          return fork(discount_pack);

        case 46:
          _context.next = 48;
          return fork(bronze_test);

        case 48:
          _context.next = 50;
          return fork(homemade);

        case 50:
          _context.next = 52;
          return fork(online_test_log);

        case 52:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}